import {DigitalPageItem} from '../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Paid,
  Title: 'Hello!',
  ProductCode: 'heawo43',
  Description:
    'Here\'s all the online content included with your <strong>The American West Complete Revision and Practice</strong>.',
  Credits:
    '<i>Proofreader: Scott Thomas <br />Questions throughout based on Pearson Edexcel type questions. <br />Text, design, layout and original illustrations © Coordination Group Publications Ltd. (CGP) 2026. All rights reserved.</i>',};